"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportWebSocket = void 0;
class TransportWebSocket {
    constructor(webSocket) {
        this.webSocket = null;
        this.webSocket = webSocket;
    }
    on(eventName, callback) {
        this.webSocket.on(eventName, callback);
    }
    reconnect(data) {
        this.webSocket.reconnect(data);
    }
    isConnected() {
        return this.webSocket.isConnected();
    }
}
exports.TransportWebSocket = TransportWebSocket;
